import DeleteEntityContainer from "./DeleteEntityContainer";
export default DeleteEntityContainer;
